import React, { useState } from 'react';

export default function LeadModal({ open, onClose, onSubmit }) {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await onSubmit({ email, phone });
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-ink/40 backdrop-blur-sm">
      <div className="card-accent w-full max-w-sm shadow-soft animate-in">
        <h3 className="text-lg font-bold text-ink">Almost there</h3>
        <p className="text-sm text-muted mt-1">We need your contact to deliver the report.</p>
        <form onSubmit={submit} className="mt-5 space-y-3">
          <div>
            <label className="label">Email</label>
            <input type="email" required className="input" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="label">Mobile</label>
            <input type="tel" required className="input" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
          <button type="submit" disabled={busy} className="btn w-full">{busy ? 'Wait…' : 'Continue to payment'}</button>
          <button type="button" onClick={onClose} className="btn-ghost w-full">Cancel</button>
        </form>
      </div>
    </div>
  );
}
